// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p3-0";
export var buttonContainer = "_p3-3";
export var cancelButton = "_p3-4";
export var headerSection = "_p3-6";
export var headerTitle = "_p3-9";
export var messageSideLeft = "_p3-1";
export var messageSideRight = "_p3-2";
export var orderNumberContainer = "_p3-7";
export var orderNumberLabel = "_p3-8";
export var submitButton = "_p3-5";